export const hasSegmentFee = (pricePom: unknown, priceCpm: unknown): boolean =>
  Number(pricePom) > 0 || Number(priceCpm) > 0;
